module.exports = __webpack_public_path__ + "img/Different-Hair-Loss-Areas2@2x.2cb04b07.jpg";